// extracted by css-extract-rspack-plugin
export default {"root":"mIr8EdyflecYhR_k","icon":"yPbTSbV0IVcu6QE7","content":"SGGrsI4I8akmaqEy","toggle":"mIb02f73g90Rc7Il","details":"Hz9s2iMProLJgFpq"};